import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import apiService from '../../services/apiServices'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import { Bars } from 'react-loader-spinner'
import { useForm } from 'react-hook-form';

const EmployeesList = () => {
    const [loader, setLoader] = useState(true);
    const [items, setItems] = useState();
    const alert = { open: false, message: '', variant: '' };
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
   
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        control,
        formState: { errors },
    } = useForm();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getData = () => {
        setLoader(true)
        apiService().get('workers')
            .then(response => {
                if (response.success && response.data.length > 0) {
                    setItems(response?.data)
                    setLoader(false)
                }
                else {
                    setLoader(false)
                    setItems([])
                }
            })
    }
    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <div>
                {loader && <div className="loader-class"><Bars
                    height="70"
                    width="100%"
                    color="#1976d2"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                /></div>}
                {!loader && <>

                    <TopActions />
                    <TableContainer component={Paper}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nr</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Id</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items?.length === 0 &&
                                    <TableRow>
                                        <TableCell colSpan={8} style={{ textAlign: 'center' }}>No Data</TableCell>
                                    </TableRow>
                                }
                                {items?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((w, index) => (
                                        <TableRow key={w.Id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <Link to={`/home/reports/employee-card/${w.Id}`}>
                                                    {w.name}
                                                </Link>
                                            </TableCell>
                                            <TableCell>{w.PersonalId}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={items?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </>}
            </div>
        </div>
    )
}

export default EmployeesList